<template>
<div>
    <main class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
        <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        </section>
        <section class="section section-skew">
        <div class="container">
            <!-- <div class="card card-profile shadow mt--300"> -->
            <div class="card card-profile shadow newmargintopcard">
            <div class="px-4">
                <div class="row justify-content-center">
                <div class="col-lg-3 order-lg-2">
                    <div class="card-profile-image">
                    <a href="#">
                        <img v-bind:src="user.users_picture" class="rounded-circle">
                    </a>
                    </div>
                </div>
                <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
                    <div class="card-profile-actions py-4 mt-lg-0">
                    <router-link to="/user" class="btn btn-sm btn-default mr-4"><i class="fa fa-dashboard"></i> หน้าแรก</router-link>
                    <a href="/logout" class="btn btn-sm btn-danger float-right"><i class="fa fa-sign-out"></i> ออกจากระบบ</a>
                    </div>
                </div>
                <div class="col-lg-4 order-lg-1">
                    <div class="card-profile-stats d-flex justify-content-center">
                    <div>
                        <span class="heading">{{ dashboard.count_shops_all }}</span>
                        <span class="badge badge-primary">จำนวนร้านค้า</span>
                    </div>
                    <div>
                        <span class="heading"><b>{{ dashboard.unpaid_today }}</b></span>
                        <span class="badge badge-warning">ค้างชำระวันนี้</span>
                    </div>
                    <div>
                        <span class="heading"><b>{{ dashboard.unpaid_all }}</b></span>
                        <span class="badge badge-danger">ค้างชำระทั้งหมด</span>
                    </div>
                    </div>
                </div>
                </div>
                <div class="text-center mt-5">
                <h3>{{ user.users_name }} {{ user.users_lastname }}</h3>
                <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>@{{ user.users_id }}</div>
                
                <div class="container mt-4">
                    <div class="row justify-content-md-center">
                    <div class="col col-lg-4">
                        <p class="h4 text-warning">
                            ฿ {{ today_balance.str_money }}
                        </p>
                        <b>ยอดเงินรวมที่ได้ของวันนี้</b>
                    </div>
                    
                    <div class="col col-lg-4">
                        <p class="h4 text-warning">
                            ฿ {{ month_balance.str_money }}
                        </p>
                        <b>ยอดเงินที่ถอนออกได้</b>
                    </div>
                </div>

                <div class="container mt-5">
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-6">
                            <router-link tag="div" to="/user/mangeshops" class="btn btn-1 btn-default" active-class="active">
                                <span class="btn-inner--icon">
                                    <i class="ni ni-shop"></i>
                                </span> จัดการร้านค้า
                            </router-link>

                            <router-link to="/user/transfers" class="btn btn-1 btn-default" active-class="active">
                                <span class="btn-inner--icon">
                                    <i class="ni ni-bullet-list-67"></i>
                                </span> ประวัติธุรกรรม
                            </router-link>

                            <router-link tag="div" to="/user/setting" class="btn btn-1 btn-default" active-class="active">
                                <span class="btn-inner--icon">
                                    <i class="ni ni-ui-04"></i>
                                </span> ตั้งค่า
                            </router-link>
                        </div>
                    </div>
                </div>
                
                
            </div>
            </div>
            <div class="mt-5">
                
                <fade-transition origin="center" mode="out-in" :duration="250">
                    <router-view></router-view>
                </fade-transition>

            </div>
        </div>
        </div>
        </div>
        </section>
    </main>
</div>
</template>

<script>
import UserStore from "@/stores/UserStore";
import Dashboard from "@/stores/Dashboard";
import router from "@/router";
import { FadeTransition } from "vue2-transitions";

export default {
  name: "Profile",
  components: {
    FadeTransition
  },
  data() {
    return {
      user: [],
      dashboard: [],
      today_balance: {
          str_money: null
      },
      month_balance: {
          str_money: null
      },
    };
  },
  methods: {
    getUser: async function() {
      if (!localStorage.access_token) router.push("/");
      let optionts = {
        access_token: localStorage.access_token
      };
      await UserStore.dispatch("getUser", optionts);
      // console.log(UserStore.state.user.user);
      // console.log(UserStore.state.user.status);
      if (UserStore.state.user.status == 200) {
        this.user = UserStore.state.user.user;
      } else if (UserStore.state.user.status == 400) {
        router.push("/logout");
      }
    },
    getDashboard: async function() {
      if (!localStorage.access_token) router.push("/");
      let optionts = {
        access_token: localStorage.access_token
      };
      await Dashboard.dispatch("getDashboard", optionts);
    //   console.log(Dashboard.state.dashboard);
      if (Dashboard.state.dashboard.status == 200) {
        this.dashboard = Dashboard.state.dashboard
        this.today_balance.str_money = Dashboard.state.dashboard.today_balance.str_money
        this.month_balance.str_money = Dashboard.state.dashboard.month_balance.str_money
      } else if (Dashboard.state.dashboard.status == 400) {
        router.push("/logout");
      }
    }
  },
  async mounted() {
    await this.getUser();
    await this.getDashboard();
  }
};
</script>

<style>
/* #example_filter , #example_length {
        text-align: right;
    } */
.newmargintopcard {
  margin-top: -300px !important;
}
.btn-default:not(:disabled):not(.disabled):active,
.btn-default:not(:disabled):not(.disabled).active,
.show > .btn-default.dropdown-toggle {
  color: #fff !important;
  border-color: #fb6340 !important;
  background-color: #fb6340 !important;
}
</style>
